<template>
  <div
    class="col-md-3"
    :id="'attribute'+index"
  >
    <label
      class="form-label me-2"
    >
      {{ $t('Attribute') + ' ' + (index + 1) }}
    </label>
    <label
      class="form-label text-danger"
      style="cursor: pointer;"
      @click="$parent.deleteItem(index)"
      v-if="index != 0 && oldAttributeId == ''"
    >
      <i
        class="fa-solid fa-trash"
      />
      {{ $t('Delete') }}
    </label>
    <select2
      v-model.trim="v$.attribute.id.$model"
      @select="selectAttribute"
      :options="select2FormAttributes.options"
      :settings="select2FormAttributes.setting"
      :disabled="oldAttributeId != ''"
    />
  </div>
  <div
    class="col-md-9"
    :id="'attributeOption'+index"
  >
    <label
      class="form-label"
    >
      {{ $t('Options') + ' ' + (index + 1) }}
    </label>
    <select2
      v-model.trim="v$.attribute.option_ids.$model"
      @select="selectOption"
      :options="select2FormAttributeOptions.options"
      :settings="select2FormAttributeOptions.setting"
      :disabled="attribute.id == ''"
      :placeholder="$t('Select additional options') + '...'"
    />
  </div>
</template>


<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-attribute";
import { AUTH, API_URLS } from '@/services/endpoint/_constants';
import Select2 from 'vue3-select2-component';
import signature  from '@/services/signature';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.attribute)
  },
  props: {
    attribute: {
      type: Object,
      default: []
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    let vm = this;
    return {
      select2FormAttributes: {
        options: vm.attribute ? [{
          id: vm.attribute.id,
          text: vm.attribute.name,
          options: vm.attribute.all_options,
        }]: [],
        setting: {
          placeholder: vm.$t('Select')+'...',
          dropdownParent: '#attribute'+vm.index,
          minimumResultsForSearch: true,
          multiple: false,
          language: {
            maximumSelected: function (e) {
              return vm.$t('You can only select') + ' ' + e.maximum + ' ' + vm.$t('items');
            },
            loadingMore: function (e) {
              return '<i class="fa-solid fa-spinner fa-spin" />'
            }
          },
          ajax: {
            beforeSend: function (request) {
              request.setRequestHeader('Authorization', 'Bearer ' + AUTH.TOKEN);
            },
            url: AUTH.URL + API_URLS.API_PRODUCT_ATTRIBUTE,
            data: function (params) {
              var query = {
                search: params.term,
                page: params.page || 1,
                branch_id: 1,
                limit: 10
              };
              return signature($.param(query)).substring(1);
            },
            processResults: function (res, params) {
              let data = res.data;
              let pageCurrent = res.meta.current_page;
              data = data.map(function(item) {
                return {
                  id: item.id,
                  text: item.name,
                  options: item.options,
                  disabled: vm.$parent.form.attributes.find((attribute) => attribute.id == item.id)? true: false
                }
              });
              return {
                results: data,
                pagination: {
                  more: (pageCurrent * 10) < res.meta.total
                }
              }
            }
          }
        },
      },
      oldAttributeId: vm.attribute.id,
      select2FormAttributeOptions: {
        options: vm.attribute && vm.attribute.all_options ? vm.attribute.all_options.map((option) => {
          return {
            id: option.id,
            attribute_id: option.attribute_id,
            text: option.name,
            name_en: option.name_en,
            code: option.code
          }
        }): [],
        setting: {
          dropdownParent: '#attributeOption'+vm.index,
          minimumResultsForSearch: true,
          multiple: true,
        }
      },
    }
  },
  components: {
    Select2
  },
  methods: {
    async selectOption(e) {
      if (!e || !e.id) return;
      this.$emit('update-variants', {
        id: e.id,
        attribute_id: e.attribute_id,
        name: e.text,
        name_en: e.name_en,
        code: e.code,
        selected: e.selected
      });
      this.v$.$touch();
      if(!this.v$.$invalid) {
        this.$parent.inValidFormAttribute = false;
        return;
      }
      this.$parent.inValidFormAttribute = true;
    },
    async selectAttribute(e) {
      // ถ้าเปลี่ยนจาก Attribute เดิม -> แจ้ง Parent ให้ลบ Variants ของอันเก่าทิ้ง
      if (this.oldAttributeId && this.oldAttributeId != e.id) {
        this.$emit('remove-attribute-variants', this.oldAttributeId);
      }

      // อัปเดต ID ปัจจุบัน
      this.oldAttributeId = e.id;

      // เคลียร์ค่า Option ที่เลือกไว้
      this.attribute.option_ids = [];

      // Map Options ใหม่ โดยใส่ attribute_id กำกับไว้ทุกอัน
      this.select2FormAttributeOptions.options = e.options.map((option) => {
        return {
          id: option.id,
          attribute_id: e.id,
          text: option.name,
          code: option.code
        }
      });
    }
  },
  computed: {
  }
}
</script>
